import React from 'react';
import { Container } from 'components/core/Page';
import { H2, Paragraph } from 'components/core/Typography';
import { Image } from 'components/core/Image';
import Garage from 'assets/images/icons/garage.svg';
import PublicStorage from 'assets/images/logos/public-storage.png';
import SafeguardSelfStorage from 'assets/images/logos/safeguard-self-storage.png';
import PriceSelfStorage from 'assets/images/logos/price-self-storage.png';

import './MarketingPartners.scss';

export default function MarketingPartners() {
	return (
		<Container className="marketing-partners">
			<Image
				src={Garage}
				aria-hidden="true"
				alt=""
			/>
			<H2
				size="mediumLarge"
				weight="extraBold"
			>
				Choose From 20,000+ Local, Independent, and National Storage
				Facilities
			</H2>
			<Paragraph>
				Reserve from SelfStorage.com to get exclusive deals from the
				storage facilities in your area.
			</Paragraph>
			<div className="logos-container">
				<Image
					className="public-logo"
					src={PublicStorage}
					alt="public storage logo"
				/>
				<Image
					className="safeguard-logo"
					src={SafeguardSelfStorage}
					alt="safeguard self storage logo"
				/>
				<Image
					className="price-logo"
					src={PriceSelfStorage}
					alt="price self storage logo"
				/>
			</div>
		</Container>
	);
}
